// extracted by mini-css-extract-plugin
export default {"page":"Landing_page__-ytQf","row":"Landing_row__wk8c2","col":"Landing_col__tke6y","components":"Landing_components__i774E"};